import { onAuthStateChanged, signInWithEmailAndPassword, signOut } from "firebase/auth";
import {createContext, useEffect, useState } from "react"
import {auth} from "../firebase";
export const UserContext = createContext();

const UserProvider = ({children}) => {
    const [user, setUser] = useState(false);

    useEffect(() => {
        const unsuscribe = onAuthStateChanged(auth, (user) => {
            //console.log(user) //=> para saber si es que esta logeado el usuario si o no
            if(user){
                const{email,photoURL, displayName, uid} = user;
                setUser({email,photoURL, displayName, uid });
            } else {
                setUser(null);
            }
        });

        return () => unsuscribe();
    },[]);

    const loginUser = (email, password) => signInWithEmailAndPassword(auth,email,password);

    const signOutUser = () => signOut(auth);

    return (
        <UserContext.Provider value={{user,setUser, loginUser, signOutUser}}>
            {children}
        </UserContext.Provider>
    );
}
 
export default UserProvider;
